import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { CubiqWorker } from "../../worker/CubiqWorker";

import { AllBenchmarksSharedService } from "./AllBenchmarksSharedService";

@Injectable()
export class AllBenchmarksFixingSummariesService extends AllBenchmarksSharedService<
  CubiqTS.FixingSummariesRequestImpl,
  CubiqTS.StandardReport
> {
  // compelete and release all subjects after prime

  constructor(cubiqWorker: CubiqWorker) {
    super(cubiqWorker, CubiqTS.FixingSummariesRequestImpl);
  }
}
